<template>
<div @click="bodyPartClicked">
    <v-menu v-model="menuVisible" offset-y left :nudge-bottom="0" style="width:100%">
        <template v-slot:activator="{ on }">
        <div class="btn full-width" :class="{outline, disabled: disabled, hoverable: !disabled && menuOnly}" style="display:flex;" v-on="on">
            <div ref="textPart" @click="textPartClicked" v-ripple="!this.disabled" class="text-part" :class="{hoverable: !disabled && !menuOnly, clickable: !disabled, 'menu-only': menuOnly}">
                <slot>
                {{buttonText}}
                </slot>
            </div>
            <div class="button-part" @click="buttonPartClicked" v-ripple="!this.disabled" :class="{hoverable: !disabled && !menuOnly}" >
                <v-icon style="margin-right:-2px;margin-left:-2px">mdi-menu-down</v-icon>
            </div>     
        </div>
        </template>
        <v-list>
            <v-list-item v-for="(menu, i) in menus" @click="emitClick(menu)" :key="i">
                <v-list-item-title>{{menu.text}}</v-list-item-title>
            </v-list-item>
        </v-list>            
    </v-menu>
</div>



</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
            menuVisible: false,
        
        }
    },

    components: {
        
    },
    
    props: {
        text: String,
        disabled: Boolean,
        menus: Array,
        menuOnly: Boolean,
        outline: Boolean,
        color: String,
    },

    computed: {
        buttonText () {
            return (this.text ? this.text.toUpperCase(): 'OK') 
        },
        buttonContent() {
            return this.$slots.default[0]
        }

    },

    methods: {
        bodyPartClicked() {
            if(this.disabled)
                this.menuVisible = false
        },

        textPartClicked(e) {
            console.log(e)
            
            if(this.disabled)
                return
            else if(!this.menuOnly) {
                e.stopPropagation()
                this.$emit('click', null)
            }
        },

        buttonPartClicked() {
            // if(!this.disabled)
            //     this.menuVisible = !this.menuVisible
        },


        emitClick(params) {
            this.$emit('click', params)
        },
    },

}
</script>

<style scoped>
    .btn {
        border-radius:2px;
        border-color: rgb(216, 216, 216) rgb(209, 209, 209) rgb(186, 186, 186);
        text-align:center;
        background-color: #f5f5f5;
        font-size: 0.875rem;
        font-weight: 500;
        letter-spacing: .0892857143em;
        border-width: 1px;
        margin-top:5px;margin-bottom: 5px;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    }

    .btn.outline {
        box-shadow: none;
        border: solid 1px;
    }

    .btn .text-part {
        border-right: solid 1px #bbb;
        padding:8px;
        text-transform: uppercase;
        flex-grow:1;

    }
    .btn .text-part.menu-only {
        border-right: none!important;
    }
    .btn .button-part {
        padding-top:6px;
        /* margin-right:-2px;
        margin-left:-2px; */
        flex-basis: 16px;
    }
    .btn.disabled {
        background-color:lightgray;
        color: #999;
    }
   
</style>




// WEBPACK FOOTER //
// SplitButton.vue?581c6f66